import Joi from 'joi';

// createLayout — generated by FormBuilder, hand-edit after.
export const createLayout = () => ({
    rk: { label: 'RK', control: 'text' },
    name: { label: 'filter', control: 'text' },
    ems: { label: 'Ems', control: 'text' },
});

// createSchema — .label() from createLayout() keeps Joi errors + UI labels in sync.
export const createSchema = () => {
    const layout = createLayout();
    return {
        rk: Joi.string().max(256).allow(null, '').label(layout.rk.label),
        name: Joi.string().max(256).allow(null, '').label(layout.name.label),
        ems: Joi.number().label(layout.ems.label),
    };
};

export const createEmpty = () => ({
    rk: '',
    name: '',
    ems: 0,
});
